import { Injectable } from '@angular/core';
import { selectService, selectServiceSettings } from '../../../../store/service/service.selectors';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { toSignal } from '@angular/core/rxjs-interop';
import { globalStore } from '../../../../../shared/shared.global-service';
import {
    SERVICE_SETTINGS_DOCTOR_RECORD_TYPE_DEFAULT,
    SERVICE_SETTINGS_DOCTOR_RECORD_TYPE_KEY,
} from '@libs/types/src/services/types/service-settings-doctor-record.type';


@Injectable()
export class ServiceSettingsDoctorRecordStore extends ComponentStoreV2Factory {

    service = toSignal(globalStore!.select(selectService));

    doctorRecordSettings = toSignal(globalStore!.select(
        selectServiceSettings(SERVICE_SETTINGS_DOCTOR_RECORD_TYPE_KEY, SERVICE_SETTINGS_DOCTOR_RECORD_TYPE_DEFAULT),
    ));
}
